import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';

import getAxiosInstance, {BASE_URL_TYPE} from '../../api/axios';
import * as actionCreators from '../../store/actions/index';
import PopupBase from './PopupBase';
import utilities from '../../utilities/utilities';

const axios = getAxiosInstance();
const propTypes = {
  userData: PropTypes.instanceOf(Object).isRequired,
  setLoading: PropTypes.func.isRequired,
  updateUserData: PropTypes.func.isRequired,
};

class LegalPopup extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.form = React.createRef();
    this.close = this.close.bind(this);
    this.save = this.save.bind(this);

    // Show different text depends on selected product.
    this.currentHost = BASE_URL_TYPE.PROPZONE.replace(/https:\/\/|http:\/\//, '');
    this.legalText = 'The information provided by Gridics via any and all of its software applications is for informational purposes only and is derived using proprietary and third-party data. At Gridics, we aim to deliver the most accurate and up-to-date data possible, but we cannot guarantee the accuracy of the information provided via our platform. Each user of our software applications is responsible for determining its suitability for his or her intended use or purpose and should contact a legal professional and/or architect before making any real estate investment decisions. Gridics shall have no liability for the accuracy of the data or lack thereof, or for any decisions made or not made by users, or for any action taken or not taken by users in reliance upon any of the data.';
  }

  save(e) {
    e.preventDefault();
    const {userData, setLoading, updateUserData} = this.props;
    const hosts = _.get(userData, 'userData.legal_disclaimer.hosts') || [];
    document.cookie = 'pzAcceptedDisclaimer=accepted;path=/';

    if (_.includes(hosts, this.currentHost) || !utilities.isLoggedIn(userData)) {
      this.close();
      return;
    }

    setLoading(true);
    // Save information about accepted legal disclaimer.
    axios
      .post(`${BASE_URL_TYPE.PROPZONE}/api/v1/sso-user`, {
        data: {legal_disclaimer: this.currentHost},
      })
      .then((data) => {
        updateUserData(data.data);
        setLoading(false);
        this.close();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  close() {
    this.ref.current.close();
  }

  render() {
    return (
      <PopupBase ref={this.ref} title="Legal Disclaimer" className="legal-disclaimer-popup">
        <form ref={this.form} onSubmit={this.save}>
          <div className="text">{this.legalText}</div>
          <div className="buttons">
            <input type="submit" className="btn" value="Accept" />
          </div>
        </form>
      </PopupBase>
    );
  }
}

LegalPopup.propTypes = propTypes;

const mapStateToProps = state => ({
  userData: state.user.userData,
});

const mapDispatchToProps = dispatch => ({
  setLoading: state => dispatch(actionCreators.setLoading(state)),
  updateUserData: data => dispatch(actionCreators.updateUserData(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LegalPopup);
